/**
 * COMPONENT: SendButton
 * 
 * PURPOSE:
 * Custom send button for message input
 * Replaces Stream Chat's default send button with custom icon
 * 
 * FEATURES:
 * - Custom SendIcon component for visual consistency
 * - Maintains Stream Chat's send functionality
 * - Styled with str-chat__send-button class
 * 
 * PROPS:
 * Inherits SendButtonProps from Stream Chat React SDK:
 * - sendMessage: Function to send the message
 * - ...rest: Other Stream Chat button props
 * 
 * USAGE:
 * Passed to ChannelUI component in App.tsx:
 * <ChannelUI SendButton={SendButton} />
 */

import { SendIcon } from '../../assets';
import React from 'react';
import type { SendButtonProps } from 'stream-chat-react';

const SendButton = ({sendMessage, ...rest}: SendButtonProps) => (
  <button
    className='str-chat__send-button'
    onClick={sendMessage}
    type='button'
    {...rest}
  >
    <SendIcon />
  </button>
);

export default SendButton;